"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var MenuContext = /*#__PURE__*/(0, _react.createContext)({
  prefixCls: '',
  firstLevel: true,
  inlineCollapsed: false
});
var _default = exports["default"] = MenuContext;